import React, { useEffect, useState } from "react";
import { hideModalThen } from "../../../../Helpers/ModalUtils";
import Handler from "../../../../Helpers/Handler";
import ProfileStage from "./ProfileStage";
import AadhaarStage from "./AadhaarStage";
import EmailStage from "./EmailStage";
import ThirdDocument from "./ThirdDocument";
import FinalVerify from "./FinalVerify";
import { textCapitalize } from "../../../../Helpers/Utils";

const Index = ({ associateId, stage, onVerified }) => {
    const [associateDetails, setAssociateDetails] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchAssociateDetails = async () => {
        try {
            setLoading(true);
            setAssociateDetails(null);
            const response = await Handler({ method: "get", url: `/admin/client/associate/details/${associateId}` });
            if (response?.success) {
                setAssociateDetails(response.data?.data);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const modal = document.getElementById("stageModal");
        const handleOpen = () => { fetchAssociateDetails(); };
        modal?.addEventListener("shown.bs.modal", handleOpen);
        return () => modal?.removeEventListener("shown.bs.modal", handleOpen);
    }, [associateId]);

    useEffect(() => {
        const modal = document.getElementById("stageModal");
        const handleClose = () => setAssociateDetails(null);
        modal?.addEventListener("hidden.bs.modal", handleClose);
        return () => modal?.removeEventListener("hidden.bs.modal", handleClose);
    }, []);

    const handleVerified = () => {
        hideModalThen("stageModal", () => onVerified?.());
    };

    return (
        <div className="modal fade" id="stageModal" tabIndex="-1" aria-labelledby="stageModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content border-0 shadow-sm rounded-4">
                    <div className="modal-header">
                        <h5 className="modal-title" id="stageModalLabel">{textCapitalize(stage)} Verification</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {loading || !associateDetails ? (
                            <div className="text-center p-4">Loading...</div>
                        ) : (
                            <>
                                {stage === "profile" && <ProfileStage associateDetails={associateDetails} onVerified={handleVerified} />}
                                {stage === "email" && <EmailStage associateDetails={associateDetails} onVerified={handleVerified} />}
                                {stage === "aadhaar" && <AadhaarStage associateDetails={associateDetails} onVerified={handleVerified} />}
                                {stage === "pan" && <ThirdDocument associateDetails={associateDetails} onVerified={handleVerified} />}
                                {stage === "final" && <FinalVerify associateDetails={associateDetails} onVerified={handleVerified} />}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
